import { useMutation } from 'react-query';
import { RegisterPageViewRequest } from '../../../requests/Analytics/RegisterPageViewRequest';

export const useRegisterPageView = () => {
	return useMutation(
		(params: { url: string; reference: string; meta?: string }) =>
			RegisterPageViewRequest(params),
		{ onSuccess: () => {}, onError: () => {} },
	);
};
